
const UpgradeTipCard = () => {

    return (
        <div className="w-full bg-white p-6 flex flex-col border rounded-md relative overflow-hidden">
            <span className="w-1.5 h-full absolute z-10 top-0 left-0 bg-blue-500" />
            <div className="w-full font-semibold ">
                Titulo
            </div>
            <div className="flex flex-1 justify-between text-sm" >
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </div>
        </div>
    )
}


export default UpgradeTipCard
